module.exports = __webpack_public_path__ + "static/assets/debcdba23cd27f0a4467ec4a1a822f25.png";